import { type JSX } from 'react';

import { Skeleton } from '@videoblocks/design-system';

const SKELETON_CARD_COUNT = 9;

function SkeletonCard(): JSX.Element {
    return (
        <div className="aspect-video rounded-md overflow-hidden">
            <Skeleton variant="rectangular" width="100%" height="100%" />
        </div>
    );
}

export function VideoResultsGridSkeleton(): JSX.Element {
    return (
        <div className="flex flex-col gap-3 p-4">
            <div className="relative">
                <div className="grid grid-cols-2 xl:grid-cols-3 gap-2">
                    {Array.from({ length: SKELETON_CARD_COUNT }, (_, i) => (
                        <SkeletonCard key={i} />
                    ))}
                </div>
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="flex items-center gap-2.5 bg-white/80 backdrop-blur-sm px-5 py-3 rounded-full shadow-sm border border-gray-100">
                        <svg className="w-4 h-4 animate-spin text-gray-700" fill="none" viewBox="0 0 24 24">
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            />
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            />
                        </svg>
                        <span className="text-sm font-medium text-gray-700">Searching Library...</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
